import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

if (document.querySelector('.pattern')) {
  gsap.registerPlugin(ScrollTrigger);
  gsap.config({ nullTargetWarn: false });

  const mediaQuery = window.matchMedia('(max-width: 1080px)');
  const patternEl = document.querySelector('.pattern');

  const createScrollTriggers = (offsetY) => {
    // 1. 固定表示用のトリガー (is-fix)
    ScrollTrigger.create({
      trigger: ".pattern",
      start: `top ${offsetY}px`,
      endTrigger: ".pattern-wrap",
      end: "bottom top",
      onEnter: () => patternEl.classList.add('is-fix'),
      onLeaveBack: () => patternEl.classList.remove('is-fix'),
    });

    // 2. 非表示用のトリガー (is-hide)
    // .ceremony-sec が存在する場合のみ実行
    if (document.querySelector('.ceremony-sec')) {
      ScrollTrigger.create({
        trigger: ".ceremony-sec",
        start: "top top", // .ceremony-secの上が画面の一番上に来た時
        onEnter: () => patternEl.classList.add('is-hide'),    // 通り過ぎる時
        onLeaveBack: () => patternEl.classList.remove('is-hide'), // 戻る時
      });
    }
  };

  const handleScreenChange = (e) => {
    ScrollTrigger.getAll().forEach(st => st.kill());
    const offsetY = e.matches ? 80 : 52;
    createScrollTriggers(offsetY);
  };

  handleScreenChange(mediaQuery);
  mediaQuery.addEventListener('change', handleScreenChange);
}


